import React, { Component } from "react";
import ROUTES from "../../constants/routes";
import { NavLink, withRouter } from "react-router-dom";
import ls from 'localstorage-slim';

import "./NavigationTabs.sass";
import { MoreTabsButton } from "./MoreTabsButton";

class NavigationTabs extends Component {
  hiddenScrollContainer = React.createRef();

  state = {
    totalAllowedLinks: 3,
    links: [
      {
        title: 'Info',
        route: ROUTES.PROMOTER_INFO,
      },
      {
        title: 'Email',
        route: ROUTES.PROMOTER_EMAIL,
      },
      {
        title: 'Templates',
        route: ROUTES.PROMOTER_TEMPLATES,
      },
      {
        title: 'Iframes',
        route: ROUTES.PROMOTER_IFRAMES,
      },
      {
        title: 'Themes',
        route: ROUTES.PROMOTER_THEMES,
      },
      {
        title: 'Payments',
        route: ROUTES.PROMOTER_PAYMENT_METHODS,
      },
      {
        title: 'Statistics',
        route: ROUTES.PROMOTER_STATISTICS,
      },
      {
        title: 'Analytics',
        route: ROUTES.PROMOTER_ANALYTICS,
      },
      {
        title: 'Duda Integration',
        route: ROUTES.PROMOTER_DUDA,
      },
    ]
  };

  isPageActive = (match, location, title) => {
    const isIframe = location.pathname.includes('/iframe');

    return match ||
      (isIframe && title === "Iframes");
  };

  handleMenuItemClick(link) {
    const { links, totalAllowedLinks } = this.state;
    const route = link.route;//this.goToPage(link.route);
    this.props.history.push({pathname: route});

    const linkIdx = links.findIndex(currLink => link.route === currLink.route);
    const newHiddenLink = {...links[totalAllowedLinks - 1]}

    links[totalAllowedLinks - 1] = links[linkIdx];
    links[linkIdx] = newHiddenLink;
    this.setState({links});
  }

  componentDidMount() {
    let totalAllowedLinks = 0;
    const { links } = this.state;
    const user = ls.get("user");

    if (user.hasPayNlAccount) {
      links.push({
        title: 'Balance',
        route: ROUTES.PROMOTER_BALANCE,
      })
    }

    if (this.hiddenScrollContainer.current) {
      const container = this.hiddenScrollContainer.current;
      const windowWidth = window.screen.width - 60 - 85;
      const containerWidth = container.scrollWidth;
      const tabs = container.children;

      if (windowWidth >= containerWidth) {
        this.setState({totalAllowedLinks: 99});

        return;
      }

      let totalAllowedWidth = 0;

      for (let tab of tabs) {
        if (totalAllowedWidth + tab.scrollWidth <= windowWidth) {
          totalAllowedWidth = totalAllowedWidth + tab.scrollWidth;
          totalAllowedLinks++;
        } else {
          break;
        }
      }
    }

    let targetRoute = this.props.match.path;

    if (ROUTES.NEW_EVENT_SELL === targetRoute) {
      targetRoute = targetRoute.split("/").slice(0, -1).join("/")
    }

    const targetLinkIdx = links.findIndex(currLink => targetRoute === currLink.route);

    if (targetLinkIdx >= totalAllowedLinks) {
      const newHiddenLink = {...links[totalAllowedLinks - 1]}

      links[totalAllowedLinks - 1] = links[targetLinkIdx];
      links[targetLinkIdx] = newHiddenLink;
    }

    this.setState({
      totalAllowedLinks,
      links,
    })
  }

  render() {
    const { links, totalAllowedLinks } = this.state;

    console.log(totalAllowedLinks);
    

    const menuItems = links.slice(totalAllowedLinks).map(link => ({
      text: link.title,
      onClick: (link) => this.handleMenuItemClick(link),
      data: link,
      className: 'nav-tabs__action-item'
    }))

    return (
      <nav className="nav-tabs">
        <div className="nav-tabs__container nav-tabs__container--hidden" ref={this.hiddenScrollContainer}>
          {links.map(link => {
            return (
              <div
                className="nav-tabs__item disabled"
                key={link.route}
              >
                <span>{link.title}</span>
              </div>
            )
          })}
        </div>

        <div className="nav-tabs__container nav-tabs__container--small">
          {links.slice(0, totalAllowedLinks).map(link => {
            return (
              <NavLink
                className="nav-tabs__item"
                to={link.route}
                key={link.route}
                isActive={(match, location) =>
                  this.isPageActive(match, location, link.title)
                }
              >
                <span>{link.title}</span>
              </NavLink>
            )
          })}

          {totalAllowedLinks < links.length && (
            <MoreTabsButton menuItems={menuItems} disabled={this.state.isAddEvent} />
          )}
        </div>
      </nav>
    ); 
  }
};

export default withRouter(NavigationTabs);

